import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BuildStatus, ModuleBuilderRepository, ModuleBuildStatus, RepositoryState } from '@ca/core/models';
import { FilePreviewService, RepositoryService, SignalrService } from '@ca/core/services';
import { environment } from '@ca/environment/environment';
@Component({
    selector: 'ca-repository-item',
    templateUrl: './repository-item.component.html',
    styleUrls: ['./repository-item.component.scss'],
    providers: [SignalrService],
})
export class RepositoryItemComponent implements OnInit, OnDestroy {
    get hasLog(): boolean {
        return this.latestRepoState != null && this.latestRepoState.buildStatus === BuildStatus.Failed && this.latestRepoState.urlToLogFile != null;
    }

    get buildHasRun(): boolean {
        let buildHasRun = false;
        if (this.latestRepoState != null) {
            buildHasRun =
                this.latestRepoState.buildStatus === BuildStatus.Failed ||
                this.latestRepoState.buildStatus === BuildStatus.Succeeded ||
                this.latestRepoState.buildStatus === BuildStatus.PartiallySucceeded;
        }
        return buildHasRun;
    }

    get latestRepoState(): RepositoryState | undefined {
        return this.repositoryInformation?.states;
    }

    @Input() repositoryId: string;
    @Output() onRepositoryUpdate = new EventEmitter<RepositoryState | undefined>();

    buildStatusValues = BuildStatus;

    private repositoryInformation: ModuleBuilderRepository;

    constructor(
        private filePreviewService: FilePreviewService,
        private repositoryService: RepositoryService,
        private signalRService: SignalrService,
    ) {}

    ngOnInit(): void {
        this.connectToSignalR();
        this.fetchData();
    }

    ngOnDestroy(): void {
        this.signalRService.stop();
    }

    previewLog(): void {
        if (this.latestRepoState != null) {
            this.filePreviewService.openWithURL(this.latestRepoState.urlToLogFile, 'txt');
        }
    }

    private connectToSignalR(): void {
        const callback = (val: ModuleBuildStatus): void => this.updateRepository(val);
        this.signalRService.startConnection(environment.websocketOrigin + '/modulebuilds', 'ModuleBuildStatusEvent', callback);
    }

    private updateRepository(message: ModuleBuildStatus): void {
        if (message != null && this.repositoryId === message.repositoryId) {
            this.fetchData();
        }
    }

    private fetchData(): void {
        this.repositoryService.getById(this.repositoryId).subscribe((res: ModuleBuilderRepository) => {
            this.repositoryInformation = res;
            this.onRepositoryUpdate.emit(this.latestRepoState);
        });
    }
}
